import * as React from "react";
import Component from "../../AbstractComponent";
import { EUR } from "../../../Currency/Currencies/EUR";

import Card from '@material-ui/core/Card';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { TableComponent } from "../../Partials/Table/TableComponent";

class FinancialStatementsList extends Component {
  protected statementsListPaginatorPath: string;

  constructor(public props) {
    super(props);

    if (typeof this.props.id !== "undefined") {
      this.statementsListPaginatorPath = `StatementsList_${this.props.id}`;
    }
  }

  public renderFinancialStatements(financialStatements) {

    let indexNumber = 1;
    const reverseSortedStatements = financialStatements
      .filter(statement => !!statement && !statement.removed)
      .sort((statement1, statement2) => {
        if (statement1.firstDate < statement2.firstDate) {
          return 1;
        }

        if (statement2.firstDate > statement1.firstDate) {
          return -1;
        }

        // If owner statements has same firstDate (same period), order them by newest to oldest.
        if (this.formatter.monthYearFormatDate(statement1.firstDate) === this.formatter.monthYearFormatDate(statement2.firstDate)) {
          return statement1.id - statement2.id
        }

        return  0;
      });

      reverseSortedStatements.forEach((statement, index) => {
        if (index !== reverseSortedStatements.length - 1 && this.formatter.monthYearFormatDate(statement.firstDate) === this.formatter.monthYearFormatDate(reverseSortedStatements[index + 1].firstDate)) {
          statement.indexNumber = indexNumber;
          indexNumber += 1;
          reverseSortedStatements[index + 1].indexNumber = indexNumber;
        } else {
          indexNumber = 1;
        }
      });

      // On first sort, we are sorting by oldest to newest, so we can add index number on specific order.
      // Then we need to sort again from newest to oldest.
      // @todo refactor if there is a better way for it.

      const sortedStatements = reverseSortedStatements
      .sort((statement1, statement2) => {
        if (statement1.firstDate < statement2.firstDate) {
          return 1;
        }

        if (statement2.firstDate > statement1.firstDate) {
          return -1;
        }

        // If owner statements has same firstDate (same period), order them by newest to oldest.
        if (this.formatter.monthYearFormatDate(statement1.firstDate) === this.formatter.monthYearFormatDate(statement2.firstDate)) {
          return statement2.id - statement1.id
        }

        return  0;
      });

      return sortedStatements.map((statement, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => {
              this.redirect(`/app/${this.props.agencyStatement ? "agency-statement" : "owner-statement"}/update/${statement.id}/`)
            }}
          >
            <TableCell>
              <div style={{display: "flex", alignItems: "center", justifyContent: "left", paddingTop: "4px"}}>
                <div className="icon icon-ic-finances" style={{color: "rgb(0, 188, 212)"}}></div>
              </div>
            </TableCell>
            <TableCell style={{width: "40%"}}>
              {this.formatter.monthYearFormatDate(statement.firstDate)} {statement?.indexNumber ? `- ${statement.indexNumber}` : ""}
            </TableCell>
            <TableCell style={{width: "30%"}}>
              {
                !statement?.isSent && (
                  <div style={{padding: "2px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="list-label creation-type-label">
                      {this.trans("label-not-sent")}
                    </div>
                  </div>
                )
              }
            </TableCell>
            <TableCell style={{width: "30%", textAlign: "right"}}>
              {this.formatter.formatNumber(statement?.payoutSection ? statement?.payoutSection?.result : statement?.result, new EUR())}
            </TableCell>
          </TableRow>
        );
    });
  }

  public render() {
    return (
      <div className="component has-margin-top" style={{marginTop: "0"}}>
        <Card className="card no-padding">
          <div>
            <TableComponent
              {...this.props}
              paginator={{
                name: this.statementsListPaginatorPath,
                path: this.props.app.paginator
              }}
              headers={[
                "", this.trans("label-period"), "", this.trans("result")
              ]}
              subtitle={this.trans("page/companyupdate-section/statements-tab/finance-info/nostatementsfound")}
              className="listing-table statements-listing-table with-first-border not-3-dot"
              rows={this.renderFinancialStatements(this.props.financialStatements)}
            />
          </div>
        </Card>
      </div>
    );
  }
}

export { FinancialStatementsList };
